import FingerprintJS from '@fingerprintjs/fingerprintjs';

export const getFingerprint = async () => {
    try {
        const fingerprintPromise = await FingerprintJS.load();
        const fingerprintData = await fingerprintPromise.get();

        return fingerprintData.visitorId;
    } catch (e) {
        console.error('error generating fingerprint');
        return undefined;
    }
};
